import { endpoints, REQUEST_METHODS } from '../constants';
import { adminApiSlice } from '../store';

export const adminService = adminApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdminDashboardStats: builder.query({
      query: () => ({
        url: endpoints.admin.dashboardStats,
        method: REQUEST_METHODS.GET
      })
    }),
    getAdminRequestsByDepartment: builder.query({
      query: () => ({
        url: endpoints.admin.requestsByDepartment,
        method: REQUEST_METHODS.GET
      })
    }),
    getAdminRequests: builder.query({
      query: ({ page = 1, pageSize = 20 } = {}) => ({
        url: `${endpoints.admin.requests}?page=${page}&pageSize=${pageSize}`,
        method: REQUEST_METHODS.GET
      })
    }),
    getAdminRequestByRef: builder.query({
      query: (requestRef) => ({
        url: `${endpoints.admin.requestDetail}?requestRef=${requestRef}`,
        method: REQUEST_METHODS.GET
      })
    })
  })
});

export const {
  useGetAdminDashboardStatsQuery,
  useGetAdminRequestsByDepartmentQuery,
  useGetAdminRequestsQuery,
  useLazyGetAdminRequestsQuery,
  useGetAdminRequestByRefQuery
} = adminService;
